import { render } from "./ShuffleRain.vue?vue&type=template&id=452e2f68"
import script from "./ShuffleRain.vue?vue&type=script&lang=js"
export * from "./ShuffleRain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__